 import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Terms = () => {

    const navigate = useNavigate();
        const toggleMobileMenu = () => {
        const menu = document.getElementById('mobile-menu');
        const menuIcon = document.getElementById('menu-icon');
        const closeIcon = document.getElementById('close-icon');
        menu?.classList.toggle('hidden');
        menuIcon?.classList.toggle('hidden');
        closeIcon?.classList.toggle('hidden');
    };

  return (

     <div className="bg-white text-gray-900 font-sans">
            
    <nav className="fixed w-full z-50 glass-nav transition-all duration-300 py-0" id="navbar" onClick={() => navigate('/')}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-20 items-center">
                        <div className="flex items-center gap-3 group cursor-pointer" onClick={() => window.scrollTo(0, 0)}>
                            <div className="w-10 h-10 sm:w-11 sm:h-11 bg-primary rounded-2xl flex items-center justify-center shadow-lg group-hover:rotate-12 transition-transform duration-500">
                                <span className="text-white font-extrabold text-xl sm:text-2xl">G</span>
                            </div>
                            <div className="flex flex-col -space-y-1">
                                <span className="text-xl sm:text-2xl font-black tracking-tighter text-primary group-hover:text-black transition-colors">Grabit</span>
                                <span className="text-[8px] sm:text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em]">Urban Mobility</span>
                            </div>
                        </div>
                        
                        {/* Desktop Menu */}
                        <div className="hidden md:flex items-center space-x-8 lg:space-x-10">
                            <a href="#how-it-works" className="text-gray-600 hover:text-primary font-semibold text-xs lg:text-sm uppercase tracking-wider transition-all">How it Works</a>
                            <a href="#vehicles" className="text-gray-600 hover:text-primary font-semibold text-xs lg:text-sm uppercase tracking-wider transition-all">Fleet</a>
                            <a href="#features" className="text-gray-600 hover:text-primary font-semibold text-xs lg:text-sm uppercase tracking-wider transition-all">Benefits</a>
                            <a href="#" className="bg-primary text-white px-6 lg:px-8 py-3 rounded-2xl font-bold text-xs lg:text-sm uppercase tracking-widest btn-glow hover:bg-black transition-all shadow-xl shadow-primary/20">Download App</a>
                        </div>

                        {/* Mobile Toggle */}
                        <div className="md:hidden">
                            <button className="p-2 text-primary" onClick={toggleMobileMenu}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" id="menu-icon">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor" id="close-icon">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Mobile Menu Overlay */}
                <div className="md:hidden hidden bg-white border-t border-gray-100 shadow-2xl absolute w-full left-0 transition-all duration-300" id="mobile-menu">
                    <div className="px-6 pt-8 pb-12 space-y-6">
                        <a href="#how-it-works" onClick={toggleMobileMenu} className="block text-xl font-black text-gray-900 hover:text-primary transition-colors mobile-link">How it Works</a>
                        <a href="#vehicles" onClick={toggleMobileMenu} className="block text-xl font-black text-gray-900 hover:text-primary transition-colors mobile-link">Our Fleet</a>
                        <a href="#features" onClick={toggleMobileMenu} className="block text-xl font-black text-gray-900 hover:text-primary transition-colors mobile-link">Benefits</a>
                        <div className="pt-6">
                            <a href="#" className="block w-full text-center bg-primary text-white py-5 rounded-3xl font-black text-lg shadow-xl shadow-primary/20">Download Grabbit App</a>
                        </div>
                    </div>
                </div>
    </nav>
            
   <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 py-20 px-4">
   <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-2 rounded-full bg-blue-100 text-blue-600 font-semibold text-sm mb-4">
            Legal Information
          </span>

          <h1 className="text-5xl font-black text-slate-900 mb-4">
            Terms & Conditions
          </h1>

          <p className="text-slate-500 text-lg">
            Please read these terms carefully before using our services.
          </p>

          <div className="mt-4 text-sm text-slate-400">
            Last Updated: May 2026
          </div>
        </div>

        {/* Content Card */}
        <div className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-xl border border-slate-200 overflow-hidden">

          {/* Section 1 */}
          <div className="p-8 border-b border-slate-100 hover:bg-slate-50 transition-all">
            <div className="flex items-center gap-4 mb-4">
              <div className="h-12 w-12 rounded-xl bg-blue-100 flex items-center justify-center font-bold text-blue-600">
                01
              </div>

              <h2 className="text-2xl font-bold text-slate-900">
                Acceptance of Terms
              </h2>
            </div>

            <p className="text-slate-600 leading-8">
              By accessing and using this website, you agree to comply
              with these Terms & Conditions and all applicable laws
              and regulations.
            </p>
          </div>

          {/* Section 2 */}
          <div className="p-8 border-b border-slate-100 hover:bg-slate-50 transition-all">
            <div className="flex items-center gap-4 mb-4">
              <div className="h-12 w-12 rounded-xl bg-green-100 flex items-center justify-center font-bold text-green-600">
                02
              </div>

              <h2 className="text-2xl font-bold text-slate-900">
                Use of Services
              </h2>
            </div>

            <p className="text-slate-600 leading-8">
              Users must use our services responsibly and lawfully.
              Any misuse, abuse, or unauthorized activity may result
              in suspension or termination of access.
            </p>
          </div>

          {/* Section 3 */}
          <div className="p-8 border-b border-slate-100 hover:bg-slate-50 transition-all">
            <div className="flex items-center gap-4 mb-4">
              <div className="h-12 w-12 rounded-xl bg-purple-100 flex items-center justify-center font-bold text-purple-600">
                03
              </div>

              <h2 className="text-2xl font-bold text-slate-900">
                Intellectual Property
              </h2>
            </div>

            <p className="text-slate-600 leading-8">
              All content, trademarks, logos, graphics, and materials
              displayed on this website remain the intellectual
              property of the company and may not be copied without
              permission.
            </p>
          </div>

          {/* Section 4 */}
          <div className="p-8 hover:bg-slate-50 transition-all">
            <div className="flex items-center gap-4 mb-4">
              <div className="h-12 w-12 rounded-xl bg-red-100 flex items-center justify-center font-bold text-red-600">
                04
              </div>

              <h2 className="text-2xl font-bold text-slate-900">
                Limitation of Liability
              </h2>
            </div>

            <p className="text-slate-600 leading-8">
              We shall not be liable for any direct, indirect,
              incidental, special, or consequential damages arising
              from the use of our website, products, or services.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-10 text-center">
          <div className="bg-slate-900 text-white rounded-2xl p-6">
            <h3 className="font-bold text-xl mb-2">
              Need Help?
            </h3>

            <p className="text-slate-300">
              If you have questions regarding these Terms &
              Conditions, please contact our support team.
            </p>
          </div>
        </div>

   </div>
   </div>

     <footer className="bg-white relative overflow-hidden">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
                    

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 sm:gap-20  border-b border-gray-100 ">
                        <div className="col-span-1 sm:col-span-2 md:col-span-1">
                            <div className="flex items-center gap-3 mb-6 sm:mb-8">
                                <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center shrink-0">
                                    <span className="text-white font-black text-xl">G</span>
                                </div>
                                <span className="text-2xl font-black tracking-tighter text-primary">Grabit</span>
                            </div>
                            <p className="text-gray-400 font-medium leading-relaxed mb-8 sm:mb-10 max-w-xs">Redefining urban mobility with a focus on safety, speed, and premium service since 2026.</p>
                            {/* <div className="flex space-x-4">
                                <a href="#" className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-primary hover:text-white transition-all duration-300">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" /></svg>
                                </a>
                                <a href="#" className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-primary hover:text-white transition-all duration-300">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849s-.011 3.585-.069 4.85c-.149 3.248-1.687 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07s-3.584-.012-4.849-.07c-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849s.012-3.584.07-4.849c.149-3.249 1.691-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.667.072 4.947c.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072s3.667-.014 4.947-.072c4.358-.2 6.78-2.618 6.98-6.98.058-1.28.072-1.689.072-4.948s-.014-3.667-.072-4.947c-.2-4.358-2.618-6.78-6.98-6.98-1.281-.058-1.689-.072-4.948-.072zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
                                </a>
                            </div> */}
                        </div>
                        <div>
                            <h4 className="font-black text-lg mb-6 sm:mb-8 uppercase tracking-widest text-primary">Company</h4>
                            <ul className="space-y-4 sm:space-y-6 text-gray-500 font-bold text-sm sm:text-base">
                                <li><a href="#" className="hover:text-primary transition-colors">Our Vision</a></li>
                                <li><a href="#" className="hover:text-primary transition-colors">The Fleet</a></li>
                                <li><a href="#" className="hover:text-primary transition-colors">Safety Protocol</a></li>
                                <li><a href="#" className="hover:text-primary transition-colors">Careers</a></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-black text-lg mb-6 sm:mb-8 uppercase tracking-widest text-primary">Support</h4>
                            <ul className="space-y-4 sm:space-y-6 text-gray-500 font-bold text-sm sm:text-base">
                                <li><a href="#" className="hover:text-primary transition-colors">Help Center</a></li>
                                <li><a href="#" className="hover:text-primary transition-colors">Partner with Us</a></li>
<li>
  <Link
    to="/privacy"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    className="hover:text-primary transition-colors"
  >
    Privacy Policy
  </Link>
</li>

<li>
  <Link
    to="/terms"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    className="hover:text-primary transition-colors"
  >
    Terms & Conditions
  </Link>
</li>
   </ul>
                        </div>
                        {/* <div>
                            <h4 className="font-black text-lg mb-6 sm:mb-8 uppercase tracking-widest text-primary">Stay Updated</h4>
                            <p className="text-gray-400 font-medium mb-6 sm:mb-8 text-sm">Get exclusive offers and ride updates.</p>
                            <div className="flex flex-col gap-4">
                                <input type="email" placeholder="Enter your email" className="bg-gray-50 border-none rounded-2xl px-6 py-4 w-full font-bold focus:ring-2 focus:ring-primary outline-none text-sm transition-all" />
                                <button className="bg-primary text-white py-4 rounded-2xl font-black shadow-lg shadow-primary/20 hover:bg-black transition-all text-sm">Subscribe Now</button>
                            </div>
                        </div> */}
                        <div>
                          <div className="flex space-x-4">
                                <a href="#" className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-primary hover:text-white transition-all duration-300">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" /></svg>
                                </a>
                                <a href="#" className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-primary hover:text-white transition-all duration-300">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849s-.011 3.585-.069 4.85c-.149 3.248-1.687 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07s-3.584-.012-4.849-.07c-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849s.012-3.584.07-4.849c.149-3.249 1.691-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.667.072 4.947c.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072s3.667-.014 4.947-.072c4.358-.2 6.78-2.618 6.98-6.98.058-1.28.072-1.689.072-4.948s-.014-3.667-.072-4.947c-.2-4.358-2.618-6.78-6.98-6.98-1.281-.058-1.689-.072-4.948-.072zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
                                </a>
                                  <a
    href="#"
    className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-blue-600 hover:text-white transition-all duration-300"
  >
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M22 12a10 10 0 10-11.5 9.87v-6.99H7.9V12h2.6V9.8c0-2.57 1.53-3.99 3.87-3.99 1.12 0 2.29.2 2.29.2v2.52h-1.29c-1.27 0-1.67.79-1.67 1.6V12h2.84l-.45 2.88h-2.39v6.99A10 10 0 0022 12z" />
    </svg>
  </a>

  {/* YouTube */}
  <a
    href="#"
    className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-red-600 hover:text-white transition-all duration-300"
  >
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M23.5 6.2a3 3 0 00-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 00.5 6.2 31.4 31.4 0 000 12a31.4 31.4 0 00.5 5.8 3 3 0 002.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 002.1-2.1A31.4 31.4 0 0024 12a31.4 31.4 0 00-.5-5.8zM9.75 15.5v-7l6 3.5-6 3.5z" />
    </svg>
  </a>
                            </div>
                        </div>
                        <div>
                       
                        </div>
                    </div>
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-6 text-center sm:text-left">
                        <p className="text-xs sm:text-sm font-bold text-gray-400">© 2026 Grabit Technologies. Engineered for the City.</p>
                        <div className="flex gap-6 sm:gap-8">
                            <a href="#" className="text-[10px] font-black text-gray-300 hover:text-primary uppercase tracking-widest">Global Status</a>
                            <a href="#" className="text-[10px] font-black text-gray-300 hover:text-primary uppercase tracking-widest">Accessibility</a>
                       
                        </div>
                    </div>
                </div>
     </footer>
    </div>
  );
};

export default Terms;